import { MessageFragment } from '../../types/messageFragment';

export function serializeMessageFragment(fragment: MessageFragment): Uint8Array {
  const {
    version,
    messageId,
    fragmentIndex,
    totalFragments,
    messageType,
    clientId,
    payload,
  } = fragment;

  if (!messageId || messageId.length !== 8) throw new Error('messageId must be 8 bytes');
  if (!clientId || clientId.length !== 8) throw new Error('clientId must be 8 bytes');

  const header = new Uint8Array(1 + 8 + 2 + 2 + 1 + 8); // version + messageId + fragmentIndex + totalFragments + messageType + clientId = 22 bytes
  let offset = 0;

  header[offset++] = version;

  header.set(messageId, offset);
  offset += 8;

  header[offset++] = (fragmentIndex >> 8) & 0xff;
  header[offset++] = fragmentIndex & 0xff;

  header[offset++] = (totalFragments >> 8) & 0xff;
  header[offset++] = totalFragments & 0xff;

  header[offset++] = messageType;

  header.set(clientId, offset);
  offset += 8;

  const serialized = new Uint8Array(header.length + payload.length);
  serialized.set(header, 0);
  serialized.set(payload, header.length);

  return serialized;
}